import React, { FC } from 'react';
import { Input } from '../../shared/Input';
import { SearchIcon } from '../../shared/SVG/Icons';
import { useTranslations } from '../../../hooks/useTranslationsHelper';

interface GameSearchBarProps {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  onBlur?: () => void;
  onClose?: () => void;
}

const GameSearchBarInput: FC<GameSearchBarProps> = ({ onChange, value, onBlur }): JSX.Element => {
  const { t } = useTranslations();

  return (
    <div className="game-search-bar">
      <Input
        label={t('game.search-games')}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        theme="light"
        iconLeft={<SearchIcon color="#A6A6A6" />}
      />
    </div>
  );
};

export default GameSearchBarInput;
